import { getNumberFormat } from '@cp/src/utils/commonUtils';
import { DisplayAmountProps } from './interfaces';
import { displayAmountInCrore, isNumberGreaterThanCrore } from './utils';

const DisplayAmount = (props: DisplayAmountProps) => {
  const { amount } = props;
  if (!amount) {
    return <>-</>;
  }

  const isAmountInCrore = isNumberGreaterThanCrore(amount);

  return <>{isAmountInCrore ? displayAmountInCrore(amount) : getNumberFormat(amount, 0)}</>;
};

export default DisplayAmount;
